'use client';
import React, { useState } from 'react';
import { Bell, Search, ChevronDown, Shield, User } from 'lucide-react';

const notifications = [
  { id: 'notif-1', text: 'Burial application APP-2026-0847 awaiting approval', time: '12 min ago', unread: true },
  { id: 'notif-2', text: 'Plot NYD-B3-R2-014 reserved — expires in 48 hours', time: '1 hr ago', unread: true },
  { id: 'notif-3', text: 'Invoice INV-2026-0312 is overdue by 7 days', time: '3 hrs ago', unread: true },
  { id: 'notif-4', text: 'Monthly occupancy report generated', time: 'Yesterday', unread: false },
];

export default function Topbar() {
  const [notifOpen, setNotifOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const unreadCount = notifications?.filter((n) => n?.unread)?.length;

  return (
    <header className="h-14 bg-card border-b border-border flex items-center px-6 gap-4 sticky top-0 z-20">
      {/* Search */}
      <div className="flex-1 max-w-md">
        <div className="relative">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search graves, deceased, applications..."
            className="input-base pl-9 py-1.5 text-sm"
          />
        </div>
      </div>
      <div className="flex items-center gap-2 ml-auto">
        {/* Role badge */}
        <div className="hidden sm:flex items-center gap-1.5 bg-secondary text-primary px-3 py-1 rounded-full text-xs font-600">
          <Shield size={12} />
          <span>Cemetery Officer</span>
        </div>

        {/* Notifications */}
        <div className="relative">
          <button
            onClick={() => { setNotifOpen(!notifOpen); setUserOpen(false); }}
            className="relative w-9 h-9 flex items-center justify-center rounded-lg hover:bg-muted transition-colors"
            aria-label="Notifications"
          >
            <Bell size={18} className="text-muted-foreground" />
            {unreadCount > 0 && (
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-accent rounded-full" />
            )}
          </button>
          {notifOpen && (
            <div className="absolute right-0 top-11 w-80 card-base shadow-elevated z-50 fade-in overflow-hidden">
              <div className="px-4 py-3 border-b border-border flex items-center justify-between">
                <span className="text-sm font-600">Notifications</span>
                <span className="text-xs text-accent font-600">{unreadCount} unread</span>
              </div>
              <div className="divide-y divide-border max-h-72 overflow-y-auto">
                {notifications?.map((n) => (
                  <div key={n?.id} className={`px-4 py-3 hover:bg-muted/50 cursor-pointer transition-colors ${n?.unread ? 'bg-secondary/30' : ''}`}>
                    <p className="text-sm text-foreground leading-snug">{n?.text}</p>
                    <p className="text-xs text-muted-foreground mt-1">{n?.time}</p>
                  </div>
                ))}
              </div>
              <div className="px-4 py-2 border-t border-border">
                <button className="text-xs text-primary font-600 hover:underline">View all notifications</button>
              </div>
            </div>
          )}
        </div>

        {/* User */}
        <div className="relative">
          <button
            onClick={() => { setUserOpen(!userOpen); setNotifOpen(false); }}
            className="flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-muted transition-colors"
          >
            <div className="w-7 h-7 rounded-full bg-primary flex items-center justify-center text-white text-xs font-700">
              TM
            </div>
            <span className="hidden sm:block text-sm font-500 text-foreground">T. Mthembu</span>
            <ChevronDown size={14} className="text-muted-foreground" />
          </button>
          {userOpen && (
            <div className="absolute right-0 top-11 w-52 card-base shadow-elevated z-50 fade-in overflow-hidden">
              <div className="px-4 py-3 border-b border-border">
                <p className="text-sm font-600">Thandi Mthembu</p>
                <p className="text-xs text-muted-foreground">t.mthembu@nyandeni.gov.za</p>
              </div>
              <div className="py-1">
                {['My Profile', 'Change Password', 'Settings']?.map((item) => (
                  <button key={`user-menu-${item}`} className="w-full text-left px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors">
                    {item}
                  </button>
                ))}
                <div className="border-t border-border mt-1 pt-1">
                  <button className="w-full text-left px-4 py-2 text-sm text-negative hover:bg-negative-bg transition-colors">
                    Sign Out
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}